<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import Drawer from '@/comps-sdk/components/drawer';
  import LoadingPanel from '@/comps-sdk/components/loading-panel';

  import DefaultResultPanel from './default-result-panel.svelte';

  export let loadingText = '';
  export let isShow = false;
  export let receiveResult: any = {};
  export let isLoading = false;

  let initLoadingStatus = isLoading;

  const ifLoading = (isLoading: boolean) => {
    // isLoading 是由外部设置更改的
    if (!isLoading || isLoading === initLoadingStatus) {
      console.log('loading false');
      return false;
    }
    initLoadingStatus = true;
    console.log('loading true');
    return true;
  };

  $: isShowLoading = ifLoading(isLoading);

  const dispatch = createEventDispatcher();
  const handleLoadingDone = () => {
    console.log('done!');
    isLoading = false;
  };
  const handleClose = () => {
    dispatch('close');
    isShow = false;
  };
  const handleConfirm = () => {
    dispatch('confirm');
    isShow = false;
  };
</script>

<Drawer bind:value={isShow} on:input={handleClose}>
  {#if isShowLoading}
    <LoadingPanel {isLoading} {loadingText} on:loading-done={handleLoadingDone} />
  {:else}
    <DefaultResultPanel {receiveResult} on:close={handleConfirm} />
  {/if}
</Drawer>
